import toMap from '~/misc/toMap';

export default toMap([
  'GET_DIRECT_ORDER_INFO',
  'CUSTOMER_SERVICE_CREATE_ORDER',
  'GET_DIRECT_ORDER_PAYMENT_INFO',
  'CREATE_PAY_ORDER',
]);



// WEBPACK FOOTER //
// ./src/modules/customerServicePaymentProcess/types.js